module.exports = __webpack_public_path__ + "img/scratch.44ed0507.png";